import { z } from 'zod';

export const CustomerRoleStatusSchema = z.enum(['ACTIVE', 'SUSPENDED', 'INACTIVE', 'BLOCKED']);
export type CustomerRoleStatus = z.infer<typeof CustomerRoleStatusSchema>;

export const CustomerRoleResponseSchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  status: CustomerRoleStatusSchema,
  marketingConsentAt: z.iso.datetime().nullable(),
  referredByOrganizationGroupId: z.uuid().nullable(),
  notes: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type CustomerRoleResponse = z.infer<typeof CustomerRoleResponseSchema>;
